import clone from 'lodash/cloneDeep';
import { updateSupportData, updateData } from '../../../AdvWorkflow/AdvWorkflowActions';
import { BACKEND_KEY } from '../../AccountsWorkflowConstants';

export const setViewId = (viewId, workflowId, clientId) => (dispatch) => {
  dispatch(updateSupportData(
    {
      [BACKEND_KEY]: {
        accountViewId: viewId,
      },
    },
    workflowId,
    clientId,
  ));
};

export const setDraftAccount = (draftAccount, workflowId, clientId) => (dispatch) => {
  // Make sure to clear the previous draft, otherwise it would get merged
  dispatch(updateSupportData(
    {
      [BACKEND_KEY]: {
        accountDraft: null,
      },
    },
    workflowId,
    clientId,
  ));
  dispatch(updateSupportData(
    {
      [BACKEND_KEY]: {
        accountDraft: clone(draftAccount),
      },
    },
    workflowId,
    clientId,
  ));
};

export const updateDraftAccount = (draftAccount, workflowId, clientId) => (dispatch) => {
  dispatch(updateSupportData(
    {
      [BACKEND_KEY]: {
        accountDraft: draftAccount,
      },
    },
    workflowId,
    clientId,
  ));
};

export const addDraftAccount = (draft, graphAccounts, workflowId, clientId) => (dispatch) => {
  dispatch(updateData(
    {
      [BACKEND_KEY]: graphAccounts.concat(draft),
    },
    workflowId,
    clientId,
  ));
};

export const saveDraftAccount = (draft, graphAccounts, workflowId, clientId) => (dispatch) => {
  dispatch(updateData(
    {
      [BACKEND_KEY]: graphAccounts.map((graphAccount) => {
        if (
          (draft.AccountId !== null && graphAccount.AccountId === draft.AccountId) ||
            (draft.AccountId === null && graphAccount.frontEndId === draft.frontEndId)
        ) {
          return clone(draft);
        }
        return graphAccount;
      }),
    },
    workflowId,
    clientId,
  ));
};
